import React from "react";

import {
    Button,
    Card,
    Checkbox,
    Col,
    DatePicker,
    Icon,
    Input,
    InputNumber,
    List,
    message,
    notification,
    Popconfirm,
    Popover,
    Row,
    Select,
    Switch,
    Table,
    Tooltip,
    Upload
} from "antd";

import { DOC_ORDER_TYPES, getOrderDocumentLink, renderVariantName } from "../../../orders-v2/modal";

import { URL_ENDPOINT, SUPPLIER_URL } from '../../../../index';

const productionEnvString = "production";
const Option = Select.Option;

class PurchaseInvoiceButton extends React.Component {

    constructor(props) {
        super(props);

        this.state = {
            purchaseInvoiceProducts: [],
            purchaseInvoiceTermsId: false,
            purchaseInvoiceDate: false,
            uploadToQuickbooks: true
        }
    }

    render() {

        const { permissions } = this.props.user.data

        const {
            supplierId,
            supplierIndex,
        } = this.props;

        if (!permissions.ezFinance) {
            return null;
        }

        const { cart } = this.props;

        let products = cart.confirmCheckout[supplierIndex].products;

        const link = getOrderDocumentLink({
            cart: this.props.cart,
            docOrderType: DOC_ORDER_TYPES.PURCHASE_INVOICE,
            supplierId
        });

        if (link) {
            return (
                <a
                    target="_blank"
                    href={link}>
                    <Button
                        className="fulfilled-button">
                        Purchase Invoice
					</Button>
                </a>
            );
        }

        return (
            <Popover
                trigger="click"
                title="Upload Purchase Invoice"
                content={
                    <Row>
                        <Table
                            title={ this.renderTableTitle }
                            scroll={{ y: 300 }}
                            columns={this.getColumns()}
                            dataSource={products}
                            pagination={false}
                        />

                        <Row type="flex" justify="center">
                            <Upload
                                withCredentials
                                data={{
                                    date: JSON.stringify(this.state.purchaseInvoiceDate),
                                    termsId: this.state.purchaseInvoiceTermsId,
                                    products: JSON.stringify(this.state.purchaseInvoiceProducts),
                                    uploadToQuickbooks: this.state.uploadToQuickbooks
                                }}
                                action={`${URL_ENDPOINT}/api/admin/order-docs/upload-purchase-invoice/${cart._id}/${supplierId}/${this.props.user.data.details.name}`}
                                onChange={(info) => this.onUploadStateChange(info)}
                            >
                                <Button
                                    onClick={() => console.log(this.state.purchaseInvoiceProducts)}
                                    type="primary">Create Bill</Button>
                            </Upload>
                        </Row>
                    </Row>
                }
            >
                <Button
                    onClick={(e) => this.onClickPurchaseInvoiceButton(supplierIndex)}>
                    Purchase Invoice
                    </Button>
            </Popover>
        )
    }

    renderTableTitle = () => {

        const { qbTerms } = this.props;

        return (
            <Row
                type="flex"
                justify="start"
                gutter={8}
                >

                <Col>
                    <Row>
                        Terms
                        </Row>
                    <Row>
                        <Select
                            onChange={(value) => this.onChangeQbTermsId(value)}
                            value={this.state.purchaseInvoiceTermsId}
                            style={{ width: 150 }}>

                            {Object.keys(qbTerms).map(_key =>
                                <Option value={qbTerms[_key].Id}>
                                    {qbTerms[_key].Name}
                                </Option>
                            )}

                        </Select>
                    </Row>
                </Col>

                <Col>
                    <Row>
                        Date of bill
                        </Row>
                    <Row>
                        <DatePicker
                            onChange={this.onChangePurchaseInvoiceDate}
                            value={this.state.purchaseInvoiceDate}
                        />
                    </Row>
                </Col>

                <Col>
                    <Row>
                        Upload to Quickbooks
                    </Row>
                    <Row>
                        <Switch
                            checkedChildren='Yes'
                            unCheckedChildren='No'
                            defaultChecked
                            onChange={ checked => this.setState({ uploadToQuickbooks: checked}) }
                        />
                    </Row>
                </Col>
            </Row>
        );
    }

    getColumns = () => {

        const { qbExpenseAccounts } = this.props;
        const { purchaseInvoiceProducts } = this.state;

        return [
            {
                title: 'Account',
                width: 150,
                render: (record, _record, index) => (
                    <Select
                        onChange={(value) => this.onChangeProductAccountId(value, index)}
                        value={purchaseInvoiceProducts[index].accountId}
                        style={{ width: 150 }}
                    >
                        {Object.keys(qbExpenseAccounts).map(_key =>
                            <Option value={qbExpenseAccounts[_key].Id}>
                                {qbExpenseAccounts[_key].Name}
                            </Option>
                        )}
                    </Select>
                )
            },
            {
                title: 'Title',
                width: 200,
                render: (record) => (
                    record.orderStatus.cantFulfill ?
                        <span
                            style={{
                                color: "#f5222d",
                                textDecoration: "line-through"
                            }}
                        >
                            <span style={{ color: "rgba(0, 0, 0, 0.65)" }}>{record.product.title}</span>
                        </span>
                        :
                        record.product.title
                )
            },
            {
                title: 'Var',
                width: 100,
                dataIndex: 'variants',
                render: (variants) => {
                    return (
                        renderVariantName(variants)
                    )
                }
            },
            {
                title: 'Qty',
                width: 50,
                dataIndex: 'quantity',
                render: (quantity) => {

                    return (
                        <span>{quantity}</span>
                    );

                }
            },
            {
                title: 'Total Cost',
                width: 100,
                render: (record, _record, index) => {

                    return (
                        <InputNumber
                            onChange={(value) => this.onChangeProductCost(value, index)}
                            style={{ width: 100 }}
                        />
                    );

                }
            }
        ];

    }

    onChangeProductAccountId = (value, index) => {

        let { purchaseInvoiceProducts } = this.state

        this.setState({
            purchaseInvoiceProducts: purchaseInvoiceProducts.map((_product, _index) => {
                if (index === _index) {
                    return {
                        ..._product,
                        accountId: value
                    }
                }

                return _product
            })
        })
    }

    onChangeProductCost = (value, index) => {

        let { purchaseInvoiceProducts } = this.state

        this.setState({
            purchaseInvoiceProducts: purchaseInvoiceProducts.map((_product, _index) => {
                if (index === _index) {
                    return {
                        ..._product,
                        cost: value
                    }
                }

                return _product
            })
        })

    }

    onChangePurchaseInvoiceDate = (date) => {

        this.setState({ purchaseInvoiceDate: date })
        
    }

    onChangeQbTermsId = (value) => {
		this.setState({ purchaseInvoiceTermsId: value })
	}

    onClickPurchaseInvoiceButton = (supplierIndex) => {

        const {
            cart,
            qbExpenseAccounts
        } = this.props;

        console.log(cart, supplierIndex);

        let _productOrders = cart.confirmCheckout[supplierIndex].products;

        this.setState({
            purchaseInvoiceProducts: _productOrders.map(_productOrder => {

                return ({
                    productId: _productOrder._id,
                    cost: _productOrder.cost,
                    accountId:
                        process.env.NODE_ENV == productionEnvString ?
                            qbExpenseAccounts["Supplies and materials - COS"].Id
                            :
                            qbExpenseAccounts["Cost of sales"].Id
                });

            })
        });

    }

    onUploadStateChange = async (info) => {

		// handle error firsts
		if (info.file.status === "error") {
			message.error(`Error uploading purchase invoice for ${this.props.cart.adminControls.offlineReferenceNumber}`, 10);
		}

		if (info.file.status === "done" && info.file.response.success) {

			const { cart, orderDocuments } = info.file.response;

            message.success(`Purchase Invoice uploaded for ${cart.adminControls.offlineReferenceNumber}`);
            
            await this.props.onUploadPurchaseInvoiceSuccess({
                cart,
                orderDocuments
            });

		}

	}

}

export default PurchaseInvoiceButton;


// WEBPACK FOOTER //
// ./src/components/orders-v3/modal/supplier-management-panel/purchase-invoice-button.js